import React from 'react'

export default function OpportunitiesCountriesSliderLoading() {
  return (
    <div className="mt-4 grid w-full grid-cols-12 gap-6">
      <div className="col-span-1 hidden lg:col-span-2 lg:block">
        <div className="flex h-full flex-col items-center justify-center">
          <div className="bg-muted-300 h-[64px] w-[101px] animate-pulse"></div>
          <div className="bg-muted-300 mt-3 h-[18px] w-[135px] animate-pulse"></div>
        </div>
      </div>
      <div className="col-span-1 hidden lg:col-span-2 lg:block">
        <div className="flex h-full flex-col items-center justify-center">
          <div className="bg-muted-300 h-[64px] w-[101px] animate-pulse"></div>
          <div className="bg-muted-300 mt-3 h-[18px] w-[99px] animate-pulse"></div>
        </div>
      </div>
      <div className="col-span-1 hidden md:col-span-3 md:block lg:col-span-2">
        <div className="flex h-full flex-col items-center justify-center">
          <div className="bg-muted-300 h-[64px] w-[101px] animate-pulse"></div>
          <div className="bg-muted-300 mt-3 h-[18px] w-[120px] animate-pulse"></div>
        </div>
      </div>
      <div className="col-span-1 hidden sm:col-span-4 sm:block md:col-span-3 lg:col-span-2">
        <div className="flex h-full flex-col items-center justify-center">
          <div className="bg-muted-300 h-[64px] w-[101px] animate-pulse"></div>
          <div className="bg-muted-300 mt-3 h-[18px] w-[150px] animate-pulse"></div>
        </div>
      </div>
      <div className="col-span-6 sm:col-span-4 md:col-span-3 lg:col-span-2">
        <div className="flex h-full flex-col items-center justify-center">
          <div className="bg-muted-300 h-[64px] w-[101px] animate-pulse"></div>
          <div className="bg-muted-300 mt-3 h-[18px] w-[100px] animate-pulse"></div>
        </div>
      </div>
      <div className="col-span-6 sm:col-span-4 md:col-span-3 lg:col-span-2">
        <div className="flex h-full flex-col items-center justify-center">
          <div className="bg-muted-300 h-[64px] w-[101px] animate-pulse"></div>
          <div className="bg-muted-300 mt-3 h-[18px] w-[140px] animate-pulse"></div>
        </div>
      </div>
    </div>
  )
}
